var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1008_78912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7442 8.33C15.1561 6.80882 14.1352 5.49331 12.8076 4.54604C11.48 3.59878 9.90394 3.06129 8.2742 3C6.64446 3.06129 5.0684 3.59878 3.7408 4.54604C2.41321 5.49331 1.39228 6.80882 0.804201 8.33C0.764485 8.43985 0.764485 8.56015 0.804201 8.67C1.39228 10.1912 2.41321 11.5067 3.7408 12.454C5.0684 13.4012 6.64446 13.9387 8.2742 14C9.90394 13.9387 11.48 13.4012 12.8076 12.454C14.1352 11.5067 15.1561 10.1912 15.7442 8.67C15.7839 8.56015 15.7839 8.43985 15.7442 8.33ZM8.2742 13C5.6242 13 2.8242 11.035 1.8092 8.5C2.8242 5.965 5.6242 4 8.2742 4C10.9242 4 13.7242 5.965 14.7392 8.5C13.7242 11.035 10.9242 13 8.2742 13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27442 5.5C7.68107 5.5 7.10105 5.67595 6.6077 6.00559C6.11436 6.33524 5.72984 6.80377 5.50278 7.35195C5.27571 7.90013 5.2163 8.50333 5.33206 9.08527C5.44782 9.66721 5.73354 10.2018 6.15309 10.6213C6.57265 11.0409 7.1072 11.3266 7.68914 11.4424C8.27109 11.5581 8.87429 11.4987 9.42247 11.2716C9.97064 11.0446 10.4392 10.6601 10.7688 10.1667C11.0985 9.67336 11.2744 9.09334 11.2744 8.5C11.2744 7.70435 10.9583 6.94129 10.3957 6.37868C9.83313 5.81607 9.07006 5.5 8.27442 5.5ZM8.27442 10.5C7.87885 10.5 7.49217 10.3827 7.16328 10.1629C6.83438 9.94318 6.57803 9.63082 6.42666 9.26537C6.27528 8.89991 6.23567 8.49778 6.31284 8.10982C6.39002 7.72186 6.5805 7.36549 6.8602 7.08579C7.13991 6.80608 7.49627 6.6156 7.88423 6.53843C8.2722 6.46126 8.67433 6.50087 9.03978 6.65224C9.40523 6.80362 9.71759 7.05996 9.93735 7.38886C10.1571 7.71776 10.2744 8.10444 10.2744 8.5C10.2744 9.03043 10.0637 9.53914 9.68863 9.91421C9.31356 10.2893 8.80485 10.5 8.27442 10.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1008_78912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.274414 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.0c8cdb45715f264565b09c39f6473aad.svg";
export { ForwardRef as ReactComponent };